import React from 'react';

const Loading = () => (
   <div className="loading-container">
      <span className="loading" />
   </div>
);

export default Loading;
